import { render, staticRenderFns } from "./ServidoresOLTVlan.vue?vue&type=template&id=292b60c5&"
import script from "./ServidoresOLTVlan.vue?vue&type=script&lang=js&"
export * from "./ServidoresOLTVlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports